import Head from 'app/components/cashout/cashout_history/Head';
import HeadMobile from 'app/components/cashout/cashout_history/HeadMobile';
import Row from 'app/components/cashout/cashout_history/Row';
import RowMobile from 'app/components/cashout/cashout_history/RowMobile';
import React, {Component, ReactNode} from 'react';
import I18n from 'app/i18n';
import {isDesktop, getLinkPath, scrollToTop} from 'app/utils';
import TableEmptyState from 'app/components/table/empty_state';
import ShowMore from 'app/utils/ShowMore';
import {inject, observer} from 'mobx-react';
import {CashoutsStoreProps} from 'app/store/CashoutsStore';
import {Link} from 'react-router-dom';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';
import CashoutInterface from 'app/interfaces/CashoutInterface';

@inject('cashoutsStore')
@observer
export default class CashoutHistory extends Component<CashoutsStoreProps> {
    state = {
        cancellingCashoutId: null,
        submitting: false
    };

    componentDidMount(): void {
        const {data} = this.props.cashoutsStore;

        if (!data?.cashouts?.length) {
            this.props.cashoutsStore.fetchHistory();
        }
        scrollToTop();
    }

    cancelCashout = (id: number): void => {
        this.setState({cancellingCashoutId: id, submitting: true});
        this.props.cashoutsStore.cancelCashout(id).finally(() => {
            this.setState({cancellingCashoutId: null, submitting: false});
        });
    };

    handleLoadMore = (): Promise<void> => this.props.cashoutsStore.loadMore(false).promise();

    render(): ReactNode {
        const {cashoutsStore} = this.props;
        const {cashouts, has_more} = cashoutsStore.data;
        const {submitting, cancellingCashoutId} = this.state;
        const CurrentComponent = isDesktop() ? Row : RowMobile;

        return <div className="cashout history--wrap">
            <div className="title">
                <Link to={getLinkPath('/withdraws')}>
                    <SpriteIcon name="#svg-back" size={{height: 8, width: 5}}/>
                    {I18n.t('button_back_label')}
                </Link>
                <h2>{I18n.t('user.history_header')}</h2>
            </div>
            <div className="history">
                <div className="table-adaptive-width">
                    <table className="table-history">
                        {isDesktop() ? <Head/> : <HeadMobile/>}
                        <tbody>
                            {cashouts.map((cashout: CashoutInterface) => <CurrentComponent
                                key={cashout.id}
                                {...cashout}
                                cancelCashout={this.cancelCashout}
                                submitting={submitting}
                                cancellingCashoutId={cancellingCashoutId}
                            />)}
                        </tbody>
                    </table>
                </div>
                <ShowMore onClickHandler={this.handleLoadMore} has_more={has_more}/>
                <TableEmptyState
                    arrayLength={cashouts.length}
                    text={I18n.t('you_have_no_cash_outs_yet')}
                />
            </div>
        </div>;
    }
}
